import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useGroupHttp } from '@/core/api/groups'
import { Group, GroupPayload } from '@/core/models/group'

export type GroupCollection = {
    data: Array<Group>,
    meta?: MetaPayload,
    links?: any
}

const state: GroupCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const groupCollection: Module<GroupCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: GroupCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: GroupPayload) => {
                state.data.push(new Group(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useGroupHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: GroupCollection): GroupCollection => {
            return state
        }
    }
}